import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function RepeatIcon({ className, size = 24, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        d="M9.64645 2.35355C9.45118 2.15829 9.45118 1.84171 9.64645 1.64645C9.84171 1.45118 10.1583 1.45118 10.3536 1.64645L12.3536 3.64645C12.403 3.69591 12.44 3.75316 12.4644 3.81425C12.4851 3.8662 12.4968 3.92093 12.4994 3.97601C12.4998 3.984 12.5 3.99201 12.5 4C12.5 4.06726 12.4867 4.13141 12.4626 4.18999C12.4392 4.24724 12.4046 4.30102 12.359 4.34805C12.3569 4.35016 12.3549 4.35226 12.3528 4.35434L10.3536 6.35355C10.1583 6.54882 9.84171 6.54882 9.64645 6.35355C9.45118 6.15829 9.45118 5.84171 9.64645 5.64645L10.7929 4.5H4.66666C3.47005 4.5 2.5 5.47005 2.5 6.66667V10.6667C2.5 10.9428 2.27614 11.1667 2 11.1667C1.72385 11.1667 1.5 10.9428 1.5 10.6667V6.66667C1.5 4.91777 2.91776 3.5 4.66666 3.5H10.7929L9.64645 2.35355Z"
        fill="currentColor"
      />
      <path
        d="M14.5 5.33334C14.5 5.0572 14.2761 4.83334 14 4.83334C13.7239 4.83334 13.5 5.0572 13.5 5.33334V9.33334C13.5 10.53 12.5299 11.5 11.3333 11.5L5.2071 11.5L6.35355 10.3536C6.54881 10.1583 6.54881 9.84171 6.35355 9.64645C6.15829 9.45119 5.84171 9.45119 5.64645 9.64645L3.64645 11.6464C3.599 11.6939 3.56308 11.7485 3.53869 11.8068C3.51377 11.8662 3.5 11.9315 3.5 12C3.5 12.0705 3.51458 12.1376 3.54091 12.1984C3.56232 12.248 3.59214 12.2948 3.63038 12.3367C3.63616 12.3431 3.64211 12.3493 3.64821 12.3553L5.64645 14.3536C5.84171 14.5488 6.15829 14.5488 6.35355 14.3536C6.54881 14.1583 6.54881 13.8417 6.35355 13.6464L5.20711 12.5H11.3333C13.0822 12.5 14.5 11.0822 14.5 9.33334V5.33334Z"
        fill="currentColor"
      />
    </svg>
  )
}
